import store from '../../store';

export default async (to, from, next) => {
    if(store.getters['authenticated']){
        if (store.getters['authenticated'] && store.getters['permissions'].includes('delete ' + to.name.split('-')[1])){
            next();
        } else {
            next({name: 'home-page'});
        }
    }else{
        next({name: 'login-page'});
    }

}